import { useState } from 'react';

const Step = ({ id, title, content, img }) => {
  const [readMore, setReadMore] = useState(false);

  const truncate = (str, numOfWords) => {
    return str.split(' ').splice(0, numOfWords).join(' ');
  };

  return (
    <div className="step">
      <h4>
        <span>{id}.</span>
        {title}
      </h4>
      <div className="desc">
        {id % 2 === 0 && img}
        <p>
          {!readMore ? (
            <>
              {truncate(content, 12)}...{' '}
              <span onClick={() => setReadMore(true)}>Read More</span>
            </>
          ) : (
            <>
              {content}{' '}
              <span onClick={() => setReadMore(false)}>Read Less</span>
            </>
          )}
        </p>
        {id % 2 !== 0 && img}
      </div>
    </div>
  );
};

export default Step;
